import { ColumnOptions } from '../types/column-options';
import { AmountColumn } from '../types/grid';
import { ColumnHostRef } from '../types/refs';

export interface PriceColumnOptions<TRow extends object>
  extends ColumnOptions<TRow, number> {
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
  getCurrency: (row: TRow | undefined) => string | undefined;
}

// Unit price: an amount column with extra fractional precision (unit prices
// commonly carry more decimals than totals). Resolves to the existing `amount`
// column type so grouping, currency and query handling stay identical.
export function priceColumn<TRow extends object>(
  ref: ColumnHostRef<TRow>,
  options: PriceColumnOptions<TRow>
): AmountColumn<TRow> {
  const column: AmountColumn<TRow> = {
    ...options,
    type: 'amount',
    format: options.format ?? 'PRICE.SYMBOL',
  };
  ref.createColumn(column);
  return column;
}
